import { Dropdown, Menu, Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ProfileView } from "../header/style";
import { FindMenus } from "./menus";
import { MenuView } from "./style";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { DefaultAdminPage, DefaultUserPage } from "../../../config";
import ReportIssueModal from "../../../components/report-issue/ReportIssueModal";
import UserList from "../../user/user-list";
import DropdownUserList from "../../user/dropdown-user-list";

const ProfileMenu = ({ user, onLogout, setData }) => {
    const { email, name, seller_name, photo } = user?.user?.user_data || {};
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showLogoutModal = () => setIsModalVisible(true);
    const handleConfirmation = () => {
        setIsModalVisible(false);
        onLogout();
    };
    const handleCancel = () => setIsModalVisible(false);

    return (
        <ProfileView
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-225px"
            data-kt-menu="true"
        >
            <div className="menu-item px-3">
                <div className="menu-content d-flex align-items-center px-3">
                    <div className="symbol symbol-40px symbol-circle me-5">
                        <img alt="Profile" src={photo || "../assets/media/avatars/blank.png"} />
                    </div>
                    <div className="d-flex flex-column" style={{ wordBreak: "break-word" }}>
                        <div className="fw-bold d-flex align-items-center fs-5">{seller_name || name}</div>
                        <a href="#" className="fw-semibold text-muted text-hover-danger fs-7">
                            {email}
                        </a>
                    </div>
                </div>
            </div>
            <div className="separator my-2" />
            {/* {user?.admin && (
                <>
                    {user.admin && <DropdownUserList userData={user} setData={setData} />}
                    <DropdownUserList userData={user} setData={setData} />

                    <div className="separator my-2" />
                </>
            )} */}
       
            {/* <div className="menu-item px-5">
                <Link to="/settings/myprofile" className="menu-link px-5">My Profile</Link>
            </div>
            <div className="menu-item px-5 my-0">
                <Link to="settings/marketplace-credentials" className="menu-link px-5">Account Settings</Link>
            </div> */}
            <div className="menu-item px-5">
                <div
                    onClick={showLogoutModal}
                    className="menu-link bg-danger text-light rounded-5 px-5 justify-content-center"
                    style={{ borderRadius: "40px", cursor: "pointer" }}
                >
                    Sign Out
                </div>
            </div>
            <Modal
                title={
                    <div className="d-flex align-items-center gap-2">
                        <ExclamationCircleOutlined style={{ color: "#f45b68", fontSize: 24 }} />
                        <span className="fw-semibold fs-4 text-danger">Confirm Logout</span>
                    </div>
                }
                open={isModalVisible}
                onOk={handleConfirmation}
                onCancel={handleCancel}
                okText="Yes, Logout"
                cancelText="Cancel"
                centered
                className="custom-logout-modal"
            >
                <p className="fs-5 text-muted mb-0">Are you sure you want to log out of your session?</p>
            </Modal>
        </ProfileView>
    );
};

export default function Sidebar({
                                    collapsed,
                                    user,
                                    setData,
                                    type,
                                    toggleSidebar,
                                    location,
                                    handleLogout,
                                    bannerHeight = 0,
                                }) {
    const [current, setCurrent] = useState(location?.pathname?.replace("/", ""));
    const [openKeys, setOpenKeys] = useState(["settings"]);
    const [currentTime, setCurrentTime] = useState("");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [reportIssueOpen, setReportIssueOpen] = useState(false);

    const [isDrpListCollapsed, setIsDrpListCollapsed] = useState(true); // true = collapsed, false = exp

    const navigate = useNavigate();

    // On Mobile (< 992px), sidebar always looks "expanded" when open (drawer mode)
    const isMobile = windowWidth < 992;

    // Expanded only based on collapsed state — hover has no effect
    const isExpanded = isMobile ? true : !collapsed;

    const findRoutes = {
        superAdmin: DefaultAdminPage,
        admin: DefaultAdminPage,
        user: DefaultUserPage,
    };

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const path = location?.pathname || "";
        setCurrent(path.replace("/", ""));
        const pathParts = path.split("/").filter(Boolean);
        if (pathParts.length > 1) {
            setOpenKeys([pathParts.slice(0, -1).join("/")]);
        }
    }, [location]);

    useEffect(() => {
        const updateTime = () => {
            const date = new Date();
            const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")} (IST)`;
            setCurrentTime(formattedDate);
        };
        updateTime();
        const intervalId = setInterval(updateTime, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const menuItems = FindMenus(type, user);
    const { email, name, seller_name, photo } = user?.user?.user_data || {};
    const asanaIssueFormUrl = "https://form.asana.com/?k=6r4M2u9PDk6_tPuM0TO8iQ&d=1202787517148468";


    return (
        <div
            id="kt_app_sidebar"
            className={`app-sidebar flex-column ${isMobile ? "drawer drawer-start" : ""}`}
            // No onMouseEnter / onMouseLeave — hover must not expand/collapse the sidebar
            style={
                bannerHeight > 0
                    ? isMobile
                        ? { top: bannerHeight }          // mobile drawer: start below banner
                        : { paddingTop: bannerHeight }   // bannerHeight desktop: push logo below banner, background still from y=0
                    : undefined
            }
        >
            {/* Sidebar Header */}
            <div
                className="app-sidebar-header d-flex align-items-center pt-8 pb-2 px-10"
                id="kt_app_sidebar_header"
                style={{ position: "relative" }}
            >
                <div className="app-sidebar-logo d-flex align-items-center">
                    <img
                        src={isExpanded ? "/assets/media/SellerView.png" : "/assets/media/sellerView-favicon.png"}
                        alt="Logo"
                        className="h-35px"
                        style={{
                            width: isExpanded ? "140px" : "30px",
                            objectFit: "contain",
                            transition: "width 0.3s ease",
                        }}
                    />
                </div>

                {/* Toggle Button — only on desktop */}
                {!isMobile && (
                    <div
                        id="kt_app_sidebar_toggle"
                        onClick={toggleSidebar}
                        className="app-sidebar-toggle btn btn-sm btn-icon bg-body btn-color-gray-600 btn-active-color-danger border shadow-sm rotate"
                        style={{
                            position: "absolute",
                            right: "-12px",
                            top: "45px",
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            cursor: "pointer",
                            zIndex: 100,
                        }}
                    >
                        <i className={`ki-outline ki-left ${collapsed ? "rotate-180" : ""} fs-8 transition-all`} />
                    </div>
                )}
            </div>

            {/* Sidebar Navs */}
            <div className="app-sidebar-navs flex-column-fluid py-6" id="kt_app_sidebar_navs">
                <div
                    id="kt_app_sidebar_navs_wrappers"
                    className="app-sidebar-wrapper hover-scroll-y my-2"
                    data-kt-scroll="true"
                    data-kt-scroll-activate="true"
                    data-kt-scroll-height="auto"
                    data-kt-scroll-dependencies="#kt_app_sidebar_header"
                    data-kt-scroll-wrappers="#kt_app_sidebar_navs"
                    data-kt-scroll-offset="5px"
                    style={{ height: `calc(100vh - 120px)` }} // 120px is an estimate for the header/footer spacing, adjust as needed
                >
           
                    {/* User Info Dropdown */}
                    <div className="app-sidebar-menu-secondary menu menu-rounded menu-column mb-0">
                        { isExpanded && <div className="card border-0 mb-2">
                            <div className="card-body p-0">
                                <div  className="menu-content d-flex flex-nowrap align-items-center ">
                                    <Dropdown
                                        trigger={["click"]}
                                        overlay={<ProfileMenu user={user} setData={setData} onLogout={handleLogout}/>}
                                        placement="bottomRight"
                                    >
                                        <div className="log-out cursor-pointer me-3">
                                            <i className="ki-outline ki-dots-horizontal fs-1 text-dark"/>
                                        </div>
                                    </Dropdown>

                                    <div className="symbol symbol-circle symbol-40px me-3 flex-shrink-0">
                                        <img alt="Logo" src={photo || "../assets/media/avatars/blank.png"}/>
                                    </div>

                                    {isExpanded && (
                                        <div className="d-flex flex-column overflow-hidden transition-all">
                                            <div className="fw-bold fs-6 text-dark text-truncate">{seller_name || name}</div>
                                            <div className="fw-semibold text-muted fs-8 text-truncate">{email}</div>
                                        </div>
                                    )}
                                </div>
                                {user?.admin && (
                                    <>
                                {/* Simple Toggle Button */}
                                <div className="mt-3 d-flex justify-content-center align-items-center p-0 border-top border-bottom">
                                    <button 
                                        onClick={() => setIsDrpListCollapsed(!isDrpListCollapsed)}
                                        className="btn btn-sm btn-light w-100"
                                    >
                                        <i className={`ki-outline ${isDrpListCollapsed ? 'ki-eye' : 'ki-eye-slash'} fs-3 me-1`}></i>
                                        {isDrpListCollapsed ? 'Show Seller Accounts' : 'Hide Seller Accounts'}
                                    </button>
                                </div>

                                {!isDrpListCollapsed &&(
                                <div className="drp-list">
                                    <DropdownUserList userData={user} setData={setData} />
                                    </div>
                                )}
                                </>
                            )}
                            </div>
                        </div>}
                    </div>

                    {isExpanded && <div className="separator border-gray-300 mb-7 mx-10"/> }

                    {/* Sidebar Menu */}
                    <div className="app-sidebar-menu-primary menu menu-column menu-rounded">
                        <MenuView className={collapsed && !isMobile ? "collapsed" : ""}>
                            <Menu
                                selectedKeys={
                                    collapsed && !isMobile
                                        ? [current, current.split("/")[0]]
                                        : [current]
                                }
                                openKeys={openKeys}
                                onOpenChange={setOpenKeys}
                                onClick={(e) => {
                                    const isParentItem = menuItems?.some(
                                        (item) => item?.key === e.key && item?.children?.length > 0
                                    );

                                    if (isParentItem && collapsed && !isMobile) {
                                        // Expand sidebar first, then open the submenu
                                        toggleSidebar();
                                        setOpenKeys([e.key]);
                                        return;
                                    }

                                    setCurrent(e.key);
                                    if (isMobile) toggleSidebar(); // Auto-close on mobile after selection
                                }}
                                theme="light"
                                mode="inline"
                                items={menuItems}
                                inlineCollapsed={!isMobile && collapsed}
                                style={{ border: "none" }}
                            />
                        </MenuView>
                    </div>
                </div>
            </div>

            {/* Sidebar Footer */}
            <div className="app-sidebar-footer d-flex flex-column px-6 pb-8" id="kt_app_sidebar_footer">

                <div className="d-flex mb-4">
                    <Tooltip title={!isExpanded ? "Report an issue" : ""} placement="right">
                        <button
                            onClick={() => setReportIssueOpen(true)}
                            className={`btn btn-light-danger d-flex align-items-center justify-content-center ${!isExpanded ? "btn-icon w-40px h-40px" : "w-100 py-3"}`}
                            type="button"
                        >
                            <i className={`ki-outline ki-information-5 ${!isExpanded ? "fs-2" : "fs-4 me-2"}`} />
                            {isExpanded && <span className="fw-bold">Report an issue</span>}
                        </button>
                    </Tooltip>
                </div>
                {user?.admin && user?.user?.user_data?.parent_user_id == null && (
                    <div className="d-flex mb-4">
                        <button
                            onClick={() => {
                                setData(user?.admin);
                                navigate(findRoutes?.[user?.admin?.loginType]);
                            }}
                            className={`btn btn-danger d-flex align-items-center justify-content-center ${!isExpanded ? "btn-icon w-40px h-40px" : "w-100 py-3"}`}
                            title={!isExpanded ? "Go to admin panel" : ""}
                        >
                            <i className={`ki-outline ki-arrow-left ${!isExpanded ? "fs-2" : "fs-4 me-2"}`} />
                            {isExpanded && (
                                <span className="fw-bold">
                                    Go to admin panel
                                </span>
                            )}
                       
                        </button>
                    </div>
                )}
           

                {isExpanded && <div className="separator border-gray-300 mb-4" />}

                <div className="d-flex align-items-center" style={{ overflow: "hidden" }}>
                    <div
                        className="d-flex justify-content-center align-items-center rounded-circle flex-shrink-0"
                        style={{
                            width: "30px",
                            height: "30px",
                            backgroundColor: "#f45b68",
                            marginRight: isExpanded ? "12px" : "0",
                            transition: "margin 0.3s ease",
                        }}
                    >
                        <i className="ki-outline ki-time fs-5 text-white" />
                    </div>

                    {isExpanded && (
                        <div className="d-flex flex-column" style={{ whiteSpace: "nowrap" }}>
                            <span className="text-muted fw-bold fs-9 text-uppercase">System Time</span>
                            <span
                                className="fw-semibold text-danger fs-8"
                                style={{ fontFamily: "'Inter', sans-serif" }}
                            >
                                {currentTime}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            <ReportIssueModal
                open={reportIssueOpen}
                onClose={() => setReportIssueOpen(false)}
                formUrl={asanaIssueFormUrl}
            />
        </div>
    );
}